import storageService from '../services/storageService';

export function sorLanguageListToPlaceInterfaceLanguageTop(list) {
  const language = storageService.getItem('psLang');
  return list.sort((x, y) =>
    x.code.toLocaleLowerCase() === language ? -1 : y.code.toLocaleLowerCase() === language ? 1 : 0,
  );
}

export function sortLanguageListAlphabetically(list) {
  return list.sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
}